export default __webpack_public_path__ + "static/media/tours_pascal.1c4a4538.jpg";